import activateDetailjs from './activate/detail..js';
import activateIndexjs from './activate/index..js';
import addressEditjs from './address/edit.js';
import addressListjs from './address/list.js';
import componentsAddressItemAddressjs from './components/AddressItem/address..js';
import componentsAddressItemIndexjs from './components/AddressItem/index..js';
import componentsAtInteceptModalIndexjs from './components/AtInteceptModal/index.js';
import componentsDetailListIndexjs from './components/DetailList/index.js';
import componentsProductInfoIndexjs from './components/ProductInfo/index.js';
import componentsWxWxSharejs from './components/Wx/WxShare.js';
import couponComponentsCountDownIndexjs from './coupon/components/CountDown/index.js';
import couponComponentsCouponItemIndexjs from './coupon/components/CouponItem/index.js';
import couponComponentsRecommendGoodsIndexjs from './coupon/components/RecommendGoods/index.js';
import couponComponentsRuleClickIndexjs from './coupon/components/RuleClick/index.js';
import couponIndexjs from './coupon/index.js';
import couponMinejs from './coupon/mine.js';
import couponUsejs from './coupon/use.js';
import couponDialogIndexjs from './couponDialog/index.js';
import deliveryDetailjs from './delivery/detail.js';
import deliveryListjs from './delivery/list.js';
import exchangeComponentsExchangeResultjs from './exchange/components/ExchangeResult..js';
import exchangeDetailjs from './exchange/detail..js';
import exchangeIndexjs from './exchange/index..js';
import exchangePhoneSearchjs from './exchange/phoneSearch..js';
import exchangeSuccessjs from './exchange/success..js';
import homeClassifyIndexjs from './home/classify/index.js';
import homeComponentsBannerIndexjs from './home/components/Banner/index.js';
import homeComponentsBeansIndexjs from './home/components/Beans/index.js';
import homeComponentsCardIndexjs from './home/components/Card/index.js';
import homeComponentsProgressIndexjs from './home/components/Progress/index.js';
import homeComponentsPublicityIndexjs from './home/components/Publicity/index.js';
import homeComponentsRushIndexjs from './home/components/Rush/index.js';
import homeIndexjs from './home/index.js';
import itemComponentsCouponCouponInPageModaljs from './item/components/Coupon/CouponInPageModal.js';
import itemComponentsCouponCouponInPageWrapperjs from './item/components/Coupon/CouponInPageWrapper.js';
import itemComponentsGroupIndexjs from './item/components/Group/index.js';
import itemComponentsOrderIndexjs from './item/components/Order/index..js';
import itemComponentsSeckillComponentIndexjs from './item/components/SeckillComponent/index.js';
import itemComponentsShareModalIndexjs from './item/components/ShareModal/index..js';
import itemComponentsVerificationIndexjs from './item/components/Verification/index..js';
import itemDetailjs from './item/detail.js';
import itemHelpersCapturejs from './item/helpers/capture..js';
import itemHelpersDetailjs from './item/helpers/detail.js';
import itemOrderjs from './item/order..js';
import itemSharejs from './item/share..js';
import itemSubscribeDetailjs from './item/subscribeDetail.js';
import itemTransSecPayjs from './item/transSec/pay..js';
import itemTransSecSubscribeUpgradejs from './item/transSec/subscribeUpgrade..js';
import modelsCouponjs from './models/coupon.js';
import orderAddressjs from './order/address..js';
import orderAlipayjs from './order/alipay..js';
import orderComponentsAddressCardjs from './order/components/AddressCard.js';
import orderComponentsChildAccountTipsjs from './order/components/ChildAccountTips..js';
import orderComponentsMastTipsjs from './order/components/MastTips..js';
import orderComponentsScanPayjs from './order/components/scanPay..js';
import orderCouponSuccessjs from './order/couponSuccess..js';
import orderCourseActivejs from './order/courseActive..js';
import orderDetailjs from './order/detail..js';
import orderListjs from './order/list..js';
import orderPayjs from './order/pay..js';
import orderPayafterjs from './order/pay.after..js';
import orderPayRecordjs from './order/payRecord.js';
import orderPendingjs from './order/pending..js';
import orderPollingResultjs from './order/pollingResult..js';
import orderProtocoljs from './order/protocol.js';
import orderScanPayIndexjs from './order/scanPay/index..js';
import orderScanPayResultjs from './order/scanPay/result..js';
import orderShareIndexjs from './order/share/index..js';
import orderStatejs from './order/state.js';
import orderSubscribeCodejs from './order/subscribeCode.js';
import orderSubscribePayjs from './order/subscribePay.js';
import orderSuccessjs from './order/success.js';
import orderWxTicketjs from './order/wxTicket..js';
import PageLoadingIndexjs from './PageLoading/index.js';
import pagesAddressCommonjs from './pages/address/common.js';
import pagesAddressComponentsAddressItemIndexjs from './pages/address/components/AddressItem/index.js';
import pagesAddressComponentsDelPopupIndexjs from './pages/address/components/DelPopup/index.js';
import pagesAddressComponentsHelpPopupIndexjs from './pages/address/components/HelpPopup/index.js';
import pagesAddressComponentsModifyResultPopIndexjs from './pages/address/components/ModifyResultPop/index.js';
import pagesAddressComponentsOrderListPopupIndexjs from './pages/address/components/OrderListPopup/index.js';
import pagesAddressEditjs from './pages/address/edit.js';
import pagesAddressEditOrderAddressIndexjs from './pages/address/EditOrderAddress/index.js';
import pagesAddressListjs from './pages/address/list.js';
import pagesAddressSearchAddressIndexjs from './pages/address/SearchAddress/index.js';
import pagesAddressSpringNoticeIndexjs from './pages/address/SpringNotice/index.js';
import pagesItemComponentsCouponComponentsCouponItemRecommendIndexjs from './pages/item/components/Coupon/components/CouponItemRecommend/index.js';
import pagesItemComponentsCouponComponentsCouponItemRecommendForSubscribeIndexjs from './pages/item/components/Coupon/components/CouponItemRecommendForSubscribe/index.js';
import pagesItemComponentsCouponCouponInPageWrapperjs from './pages/item/components/Coupon/CouponInPageWrapper.js';
import pagesItemComponentsPurchaseWayIndexjs from './pages/item/components/purchaseWay/index.js';
import pagesItemComponentsRiseInPricePopIndexjs from './pages/item/components/RiseInPricePop/index.js';
import pagesItemConfirmOrderComponentsActivityChangeModalIndexjs from './pages/item/ConfirmOrder/components/ActivityChangeModal/index.js';
import pagesItemConfirmOrderComponentsAddressIndexjs from './pages/item/ConfirmOrder/components/Address/index.js';
import pagesItemConfirmOrderComponentsAgreementIndexjs from './pages/item/ConfirmOrder/components/Agreement/index.js';
import pagesItemConfirmOrderComponentsAgreementPopIndexjs from './pages/item/ConfirmOrder/components/AgreementPop/index.js';
import pagesItemConfirmOrderComponentsAliScanSubscribePopIndexjs from './pages/item/ConfirmOrder/components/AliScanSubscribePop/index.js';
import pagesItemConfirmOrderComponentsGuideOpenInBrowserMaskIndexjs from './pages/item/ConfirmOrder/components/GuideOpenInBrowserMask/index.js';
import pagesItemConfirmOrderComponentsPayAfterProtocolPopIndexjs from './pages/item/ConfirmOrder/components/PayAfterProtocolPop/index.js';
import pagesItemConfirmOrderComponentsPayMethodsIndexjs from './pages/item/ConfirmOrder/components/PayMethods/index.js';
import pagesItemConfirmOrderComponentsPayMethodsPopIndexjs from './pages/item/ConfirmOrder/components/PayMethodsPop/index.js';
import pagesItemConfirmOrderComponentsPayResultConfirmPopIndexjs from './pages/item/ConfirmOrder/components/PayResultConfirmPop/index.js';
import pagesItemConfirmOrderComponentsPayResultPopIndexjs from './pages/item/ConfirmOrder/components/PayResultPop/index.js';
import pagesItemConfirmOrderComponentsScanPopIndexjs from './pages/item/ConfirmOrder/components/ScanPop/index.js';
import pagesItemConfirmOrderComponentsSkuDetailIndexjs from './pages/item/ConfirmOrder/components/SkuDetail/index.js';
import pagesItemConfirmOrderComponentsTimeLimitWelfareIndexjs from './pages/item/ConfirmOrder/components/TimeLimitWelfare/index.js';
import pagesItemConfirmOrderHooksUseNoPromotionPayjs from './pages/item/ConfirmOrder/hooks/useNoPromotionPay.js';
import pagesItemConfirmOrderHooksUsePayjs from './pages/item/ConfirmOrder/hooks/usePay.js';
import pagesItemConfirmOrderHooksUsePromotionPayjs from './pages/item/ConfirmOrder/hooks/usePromotionPay.js';
import pagesItemConfirmOrderHooksUseSubscribePayjs from './pages/item/ConfirmOrder/hooks/useSubscribePay.js';
import pagesItemConfirmOrderIndexjs from './pages/item/ConfirmOrder/index.js';
import pagesItemConfirmOrderPagesConfirmOrderPayV1ComponentsPriceIndexjs from './pages/item/ConfirmOrder/pages/ConfirmOrderPayV1/components/Price/index.js';
import pagesItemConfirmOrderPagesConfirmOrderPayV1ComponentsSaleOutModalIndexjs from './pages/item/ConfirmOrder/pages/ConfirmOrderPayV1/components/SaleOutModal/index.js';
import pagesItemConfirmOrderPagesConfirmOrderPayV1Indexjs from './pages/item/ConfirmOrder/pages/ConfirmOrderPayV1/index.js';
import pagesItemConfirmOrderPagesConfirmOrderPayV2ComponentsPriceIndexjs from './pages/item/ConfirmOrder/pages/ConfirmOrderPayV2/components/Price/index.js';
import pagesItemConfirmOrderPagesConfirmOrderPayV2Indexjs from './pages/item/ConfirmOrder/pages/ConfirmOrderPayV2/index.js';
import pagesItemConfirmOrderPagesPayComponentsPayMethodsForPayIndexjs from './pages/item/ConfirmOrder/pages/Pay/components/PayMethodsForPay/index.js';
import pagesItemConfirmOrderPagesPayIndexjs from './pages/item/ConfirmOrder/pages/Pay/index.js';
import pagesItemConfirmOrderPagesPayForLearningFirstComponentsPriceIndexjs from './pages/item/ConfirmOrder/pages/PayForLearningFirst/components/Price/index.js';
import pagesItemConfirmOrderPagesPayForLearningFirstIndexjs from './pages/item/ConfirmOrder/pages/PayForLearningFirst/index.js';
import pagesItemDetailComponentsDetailV1Indexjs from './pages/item/Detail/components/DetailV1/index.js';
import pagesItemDetailComponentsDetailV2ComponentsBroadcastIndexjs from './pages/item/Detail/components/DetailV2/components/Broadcast/index.js';
import pagesItemDetailComponentsDetailV2ComponentsDownloadAppPopupIndexjs from './pages/item/Detail/components/DetailV2/components/DownloadAppPopup/index.js';
import pagesItemDetailComponentsDetailV2ComponentsImageSliderIndexjs from './pages/item/Detail/components/DetailV2/components/ImageSlider/index.js';
import pagesItemDetailComponentsDetailV2ComponentsPurchaseWayIndexjs from './pages/item/Detail/components/DetailV2/components/PurchaseWay/index.js';
import pagesItemDetailComponentsDetailV2ComponentsSkuSelectPopIndexjs from './pages/item/Detail/components/DetailV2/components/SkuSelectPop/index.js';
import pagesItemDetailComponentsDetailV2Indexjs from './pages/item/Detail/components/DetailV2/index.js';
import pagesItemDetailComponentsIntroducePopIndexjs from './pages/item/Detail/components/IntroducePop/index.js';
import pagesItemDetailComponentsRenewIndexjs from './pages/item/Detail/components/Renew/index.js';
import pagesItemDetailComponentsSoldOutPopIndexjs from './pages/item/Detail/components/SoldOutPop/index.js';
import pagesItemDetailComponentsValidatePayAfterPopIndexjs from './pages/item/Detail/components/ValidatePayAfterPop/index.js';
import pagesItemDetailComponentsValidatePricePopIndexjs from './pages/item/Detail/components/ValidatePricePop/index.js';
import pagesItemDetailIndexjs from './pages/item/Detail/index.js';
import pagesItemHelpersDetailjs from './pages/item/helpers/detail.js';
import pagesItemPayjs from './pages/item/pay.js';
import pagesItemShareComponentsShareV1Indexjs from './pages/item/Share/components/ShareV1/index.js';
import pagesItemShareComponentsShareV2Indexjs from './pages/item/Share/components/ShareV2/index.js';
import pagesItemSubscribeDetailjs from './pages/item/subscribeDetail.js';
import pagesItemSubscribeUpgradejs from './pages/item/subscribeUpgrade.js';
import pagesItemTrackIndexjs from './pages/item/track/index.js';
import refundComponentsRefundPathListjs from './refund/components/RefundPathList.js';
import refundDetailjs from './refund/detail.js';
import refundListjs from './refund/list.js';
import subscribeDetailjs from './subscribe/detail..js';
import subscribeListjs from './subscribe/list..js';
import subscribePayRecordjs from './subscribe/payRecord..js';
import toMarketingIndexjs from './toMarketing/index..js';

export default {
  ...activateDetailjs,
  ...activateIndexjs,
  ...addressEditjs,
  ...addressListjs,
  ...componentsAddressItemAddressjs,
  ...componentsAddressItemIndexjs,
  ...componentsAtInteceptModalIndexjs,
  ...componentsDetailListIndexjs,
  ...componentsProductInfoIndexjs,
  ...componentsWxWxSharejs,
  ...couponComponentsCountDownIndexjs,
  ...couponComponentsCouponItemIndexjs,
  ...couponComponentsRecommendGoodsIndexjs,
  ...couponComponentsRuleClickIndexjs,
  ...couponIndexjs,
  ...couponMinejs,
  ...couponUsejs,
  ...couponDialogIndexjs,
  ...deliveryDetailjs,
  ...deliveryListjs,
  ...exchangeComponentsExchangeResultjs,
  ...exchangeDetailjs,
  ...exchangeIndexjs,
  ...exchangePhoneSearchjs,
  ...exchangeSuccessjs,
  ...homeClassifyIndexjs,
  ...homeComponentsBannerIndexjs,
  ...homeComponentsBeansIndexjs,
  ...homeComponentsCardIndexjs,
  ...homeComponentsProgressIndexjs,
  ...homeComponentsPublicityIndexjs,
  ...homeComponentsRushIndexjs,
  ...homeIndexjs,
  ...itemComponentsCouponCouponInPageModaljs,
  ...itemComponentsCouponCouponInPageWrapperjs,
  ...itemComponentsGroupIndexjs,
  ...itemComponentsOrderIndexjs,
  ...itemComponentsSeckillComponentIndexjs,
  ...itemComponentsShareModalIndexjs,
  ...itemComponentsVerificationIndexjs,
  ...itemDetailjs,
  ...itemHelpersCapturejs,
  ...itemHelpersDetailjs,
  ...itemOrderjs,
  ...itemSharejs,
  ...itemSubscribeDetailjs,
  ...itemTransSecPayjs,
  ...itemTransSecSubscribeUpgradejs,
  ...modelsCouponjs,
  ...orderAddressjs,
  ...orderAlipayjs,
  ...orderComponentsAddressCardjs,
  ...orderComponentsChildAccountTipsjs,
  ...orderComponentsMastTipsjs,
  ...orderComponentsScanPayjs,
  ...orderCouponSuccessjs,
  ...orderCourseActivejs,
  ...orderDetailjs,
  ...orderListjs,
  ...orderPayjs,
  ...orderPayafterjs,
  ...orderPayRecordjs,
  ...orderPendingjs,
  ...orderPollingResultjs,
  ...orderProtocoljs,
  ...orderScanPayIndexjs,
  ...orderScanPayResultjs,
  ...orderShareIndexjs,
  ...orderStatejs,
  ...orderSubscribeCodejs,
  ...orderSubscribePayjs,
  ...orderSuccessjs,
  ...orderWxTicketjs,
  ...PageLoadingIndexjs,
  ...pagesAddressCommonjs,
  ...pagesAddressComponentsAddressItemIndexjs,
  ...pagesAddressComponentsDelPopupIndexjs,
  ...pagesAddressComponentsHelpPopupIndexjs,
  ...pagesAddressComponentsModifyResultPopIndexjs,
  ...pagesAddressComponentsOrderListPopupIndexjs,
  ...pagesAddressEditjs,
  ...pagesAddressEditOrderAddressIndexjs,
  ...pagesAddressListjs,
  ...pagesAddressSearchAddressIndexjs,
  ...pagesAddressSpringNoticeIndexjs,
  ...pagesItemComponentsCouponComponentsCouponItemRecommendIndexjs,
  ...pagesItemComponentsCouponComponentsCouponItemRecommendForSubscribeIndexjs,
  ...pagesItemComponentsCouponCouponInPageWrapperjs,
  ...pagesItemComponentsPurchaseWayIndexjs,
  ...pagesItemComponentsRiseInPricePopIndexjs,
  ...pagesItemConfirmOrderComponentsActivityChangeModalIndexjs,
  ...pagesItemConfirmOrderComponentsAddressIndexjs,
  ...pagesItemConfirmOrderComponentsAgreementIndexjs,
  ...pagesItemConfirmOrderComponentsAgreementPopIndexjs,
  ...pagesItemConfirmOrderComponentsAliScanSubscribePopIndexjs,
  ...pagesItemConfirmOrderComponentsGuideOpenInBrowserMaskIndexjs,
  ...pagesItemConfirmOrderComponentsPayAfterProtocolPopIndexjs,
  ...pagesItemConfirmOrderComponentsPayMethodsIndexjs,
  ...pagesItemConfirmOrderComponentsPayMethodsPopIndexjs,
  ...pagesItemConfirmOrderComponentsPayResultConfirmPopIndexjs,
  ...pagesItemConfirmOrderComponentsPayResultPopIndexjs,
  ...pagesItemConfirmOrderComponentsScanPopIndexjs,
  ...pagesItemConfirmOrderComponentsSkuDetailIndexjs,
  ...pagesItemConfirmOrderComponentsTimeLimitWelfareIndexjs,
  ...pagesItemConfirmOrderHooksUseNoPromotionPayjs,
  ...pagesItemConfirmOrderHooksUsePayjs,
  ...pagesItemConfirmOrderHooksUsePromotionPayjs,
  ...pagesItemConfirmOrderHooksUseSubscribePayjs,
  ...pagesItemConfirmOrderIndexjs,
  ...pagesItemConfirmOrderPagesConfirmOrderPayV1ComponentsPriceIndexjs,
  ...pagesItemConfirmOrderPagesConfirmOrderPayV1ComponentsSaleOutModalIndexjs,
  ...pagesItemConfirmOrderPagesConfirmOrderPayV1Indexjs,
  ...pagesItemConfirmOrderPagesConfirmOrderPayV2ComponentsPriceIndexjs,
  ...pagesItemConfirmOrderPagesConfirmOrderPayV2Indexjs,
  ...pagesItemConfirmOrderPagesPayComponentsPayMethodsForPayIndexjs,
  ...pagesItemConfirmOrderPagesPayIndexjs,
  ...pagesItemConfirmOrderPagesPayForLearningFirstComponentsPriceIndexjs,
  ...pagesItemConfirmOrderPagesPayForLearningFirstIndexjs,
  ...pagesItemDetailComponentsDetailV1Indexjs,
  ...pagesItemDetailComponentsDetailV2ComponentsBroadcastIndexjs,
  ...pagesItemDetailComponentsDetailV2ComponentsDownloadAppPopupIndexjs,
  ...pagesItemDetailComponentsDetailV2ComponentsImageSliderIndexjs,
  ...pagesItemDetailComponentsDetailV2ComponentsPurchaseWayIndexjs,
  ...pagesItemDetailComponentsDetailV2ComponentsSkuSelectPopIndexjs,
  ...pagesItemDetailComponentsDetailV2Indexjs,
  ...pagesItemDetailComponentsIntroducePopIndexjs,
  ...pagesItemDetailComponentsRenewIndexjs,
  ...pagesItemDetailComponentsSoldOutPopIndexjs,
  ...pagesItemDetailComponentsValidatePayAfterPopIndexjs,
  ...pagesItemDetailComponentsValidatePricePopIndexjs,
  ...pagesItemDetailIndexjs,
  ...pagesItemHelpersDetailjs,
  ...pagesItemPayjs,
  ...pagesItemShareComponentsShareV1Indexjs,
  ...pagesItemShareComponentsShareV2Indexjs,
  ...pagesItemSubscribeDetailjs,
  ...pagesItemSubscribeUpgradejs,
  ...pagesItemTrackIndexjs,
  ...refundComponentsRefundPathListjs,
  ...refundDetailjs,
  ...refundListjs,
  ...subscribeDetailjs,
  ...subscribeListjs,
  ...subscribePayRecordjs,
  ...toMarketingIndexjs,
 }
            